"use strict";
export var SwapTab = /* @__PURE__ */ ((SwapTab2) => {
  SwapTab2["Swap"] = "swap";
  SwapTab2["Limit"] = "limit";
  SwapTab2["Dca"] = "dca";
  SwapTab2["Buy"] = "buy";
  SwapTab2["Send"] = "send";
  return SwapTab2;
})(SwapTab || {});
